<template>
  <span>{{ displayRoles }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { Optional, User } from "@/types";
import { getRoleName } from "@/util/roles";

const props = defineProps<{
  user: Optional<User>;
}>();

const displayRoles = computed((): string => {
  if (!props.user) {
    return "";
  }

  let toDisplayRoles = [];
  if (props.user.roles) {
    toDisplayRoles = props.user.roles;
  }

  for (const key in props.user) {
    if (key.startsWith("role_") && props.user[key]) {
      toDisplayRoles.push(getRoleName(key));
    }
  }
  return toDisplayRoles.map(getRoleName).join(", ");
});
</script>
